export default "__VITE_PUBLIC_ASSET__2b4fa5ab__"